'use strict';exports.__esModule = true;exports.default = function () {var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];return template.replace(/%s/g, args.shift.bind(args));};module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatMessage.js
// module id = 1303
// module chunks = 0